import { Grid } from '@mui/material';

import { InfoField, Typography, Card, CardContent, CardHeader } from '@occc-app/design-system';
import { readableDate } from '@occc-app/lib/format';
import { RetailerNetworkUserFragment } from '@occc/graphql';
import { userRoleMap } from '@occc-app/routes/User/constants';
import { formatPhoneNumberNationalForUS } from '@occc/utils-phone-number';

type RetailerNetworkUserDetailsSectionProps = {
  retailerNetworkUser: RetailerNetworkUserFragment;
};

export const RetailerNetworkUserDetailsSection = ({
  retailerNetworkUser,
}: RetailerNetworkUserDetailsSectionProps) => (
  <Card>
    <CardHeader title={<Typography variant='h6'>User Information</Typography>} />
    <CardContent>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <InfoField
            label='Mobile Phone Number'
            value={formatPhoneNumberNationalForUS(retailerNetworkUser.phoneNumber || '')}
            noDataMessage=''
          />
        </Grid>
        <Grid item xs={12} md={3} style={{ wordBreak: 'break-all' }}>
          <InfoField label='Email' value={retailerNetworkUser.emailAddress} noDataMessage='' />
        </Grid>
        <Grid item xs={12} md={3}>
          <InfoField
            label='User Role'
            value={userRoleMap[retailerNetworkUser.role]}
            noDataMessage=''
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <InfoField
            label='Date Created'
            value={readableDate(retailerNetworkUser.createdAt)}
            noDataMessage=''
          />
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);
